<template>
    <section class="gmp-section gmp-mb-l">
        <section class="gmp-section gmp-mb-l">
            <div class="subpage-hero subpage-hero--no-padding">
                <div class="two-column-tout two-column-tout--fullbleed">
                    <div class="two-column-tout__side">
                        <div class="two-column-tout__half-page two-column-tout__half-page--left">
                            <div class="two-column-tout__half-grid two-column-tout__half-grid--left">
                                <div class="two-column-tout__col">
                                    <h1 class="h-c-headline h-c-headline--display-two">
                                        有效的管理
                                    </h1>
                                    <h2 class="h-u-mb-std two-column-tout__description">
                                        经营者希望能够充分利用中央厨房的设备和人力资源，最大化生产能力，以应对多渠道、多品类订单的需求。
                                        通过优化生产流程和调度，经营者希望减少或消除生产中的瓶颈，确保生产线的顺畅运行。

                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="two-column-tout__side">
                        <div class="two-column-tout__image two-column-tout__image--right">
                            <picture>
                                <img src="@/assets/img/cl_sx_bef.png" alt="The finer points." class="gmp-no-grab " >
                            </picture>
                        </div>
                    </div>

                </div>

            </div>



        </section>

    </section>
</template>

<script>
    export default {
        name: "CK_two_column_fullbleed"
    }
</script>

<style lang="less">
h2{
    font-size: 18px;
    font-weight: 300;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}

</style>